import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Mail } from "lucide-react";
import { EASE, scrollToId } from "@/lib/scroll";

export default function FloatingContact() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.6, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6, y: 20 }}
          transition={{ duration: 0.5, ease: EASE }}
          data-testid="floating-gold-contact-btn"
          onClick={() => scrollToId("contact")}
          aria-label="Contactează-ne"
          className="group fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full border border-gold/50 bg-card/90 text-gold shadow-[0_8px_32px_rgba(212,175,55,0.25)] backdrop-blur-xl transition-colors duration-500 hover:bg-gold hover:text-ink lg:bottom-8 lg:right-8"
        >
          <span
            className="absolute inset-0 animate-ping rounded-full bg-gold/20"
            aria-hidden="true"
          />
          <Mail size={20} strokeWidth={1.6} className="relative" />
          <span className="pointer-events-none absolute right-full mr-4 whitespace-nowrap rounded-full border border-gold/30 bg-card/95 px-4 py-2 font-mono text-[9px] uppercase tracking-[0.22em] text-gold opacity-0 backdrop-blur-xl transition-all duration-400 group-hover:opacity-100">
            Contactează-ne
          </span>
        </motion.button>
      )}
    </AnimatePresence>
  );
}
